import { render, staticRenderFns } from "./Radius.vue?vue&type=template&id=0407d348&scoped=true&"
import script from "./Radius.vue?vue&type=script&lang=js&"
export * from "./Radius.vue?vue&type=script&lang=js&"
import style0 from "./Radius.vue?vue&type=style&index=0&id=0407d348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0407d348",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default,AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default,TheCustomScroll: require('/web/components/TheCustomScroll.vue').default})
